import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { IoMdImage } from 'react-icons/io';
import { useTranslation } from 'react-i18next';

import { __t } from '@mssgme/shared';
import { LazyImage } from '@mssgme/ui';
import DragIcon from '@mssgme/ui/icons/drag.svg';

import styles from './styles.scss';

// todo: reuse ProductItem here
export function ProductAdminItem({ tag: Tag = 'div', product, to, hasDragHandle = false }) {
    const { t } = useTranslation('cards');

    return (
        <div className={classNames({ [styles.root]: true, [styles.disabled]: !product.published })}>
            <Tag
                className={classNames({ [styles.productRoot]: true, [styles.fullWidth]: !hasDragHandle })}
                to={to}
                title={product.name}
            >
                <div className={styles.thumbnail}>
                    {product.photoUrl && <LazyImage src={product.photoUrl} alt={product.name} />}
                    {!product.photoUrl && (
                        <div className={styles.emptyPlaceholder}>
                            <IoMdImage size="40%" color="#fff" />
                        </div>
                    )}
                </div>
                <div className={styles.meta}>
                    <span className={styles.title}>{product.name}</span>
                    {product.price && (
                        <span className={styles.price}>
                            {product.price.formattedDiscount && (
                                <span className={styles.discountPrice}>{product.price.formattedDiscount}</span>
                            )}
                            {product.price.amount === 0 ? (
                                __t('free')
                            ) : (
                                <span
                                    className={classNames({
                                        [styles.lineThrough]: product.price.formattedDiscount,
                                    })}
                                >
                                    {product.price.formatted}
                                </span>
                            )}
                        </span>
                    )}
                </div>
            </Tag>

            {/*todo: reuse DragHandle here*/}
            {hasDragHandle && (
                <div className={styles.dragHandle} title={t('common:labels.dragTip')} data-element="drag-handle">
                    <DragIcon width="6" />
                </div>
            )}
        </div>
    );
}

ProductAdminItem.propTypes = {
    product: PropTypes.object.isRequired,
    tag: PropTypes.any,
    hasDragHandle: PropTypes.bool,
    to: PropTypes.string,
};
